<template>
  <div class="PageHeader">
    {{headerTitle}}
  </div>
</template>

<script>
export default {
  components: {
    
  },
  name: 'BreadCrumb',
  data () {
    return {
        
    }
  },
  props: {
    headerTitle: {
      type: String,
      default: ''
    },
  },
  watch: {

  },
  methods: {
    
  },
  filters: {

  },
  computed: {

  },
  created () {
    
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .PageHeader{
        font-size:24px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:29px;
    }
</style>
